export default "__VITE_ASSET__5ded4946__"